import './switcher.component.scss'
// import './switcher.component.pug'
import '../../helpers/styles/modules/poster.scss'
import '../../helpers/styles/modules/property-pack.scss'
import '../regular-section/regular-section.component'
//import { Application } from '../../helpers/app';

class Switcher {
  constructor(element) {
    this.root = element
    const initId = this.root.querySelector('.switcher-head__nav button')
      ?.dataset.id
    if (initId) {
      this.change(initId)
    }
    this.root.addEventListener('click', evt => {
      const id = evt.target.closest('button')?.dataset.id
      if (id) {
        this.change(id)
      }
    })
  }
  reset() {
    const target = {
      content: this.root.querySelector(`.switcher-content[data-active="true"]`),
      button: this.root.querySelector(
        `.switcher-head__nav button[data-active="true"]`
      )
    }
    if (target.content && target.button) {
      target.content.dataset.active = ''
      target.button.dataset.active = ''
    }
  }
  change(id) {
    const target = {
      content: this.root.querySelector(`.switcher-content[data-id="${id}"]`),
      button: this.root.querySelector(
        `.switcher-head__nav button[data-id="${id}"]`
      )
    }
    if (target.content && target.button) {
      this.reset()
      target.content.dataset.active = 'true'
      target.button.dataset.active = 'true'
    }
  }
}

document.querySelectorAll('section.switcher').forEach(element => {
  new Switcher(element)
})
